// extracted by mini-css-extract-plugin
module.exports = {"button":"app-download-button_button_c3Dlv","icon":"app-download-button_icon_3gR5h"};